const General = {
    // API_URL: 'http://localhost:7071',

    // api non-prod
    API_URL: 'https://apim-p-idb-integration.iadb.org/ext/operations/infra-dashboard-obras',

    // api-development
    // API_URL: 'https://fn-dashboard-obras.azurewebsites.net/api',

    AUTHORIZATION: '',
    REQUEST_CONFIG: {
        headers: {
            Authorization: ''
        }
    },
    NotificationType: {
        UpdateProjects: 'UpdateProjects',
        CreateObra: 'CreateObra',
        AssignProgramsAndCountriesUser: 'AssignProgramsAndCountriesUser'

    },
    NotificationStatus: [
        { Id: 0, Name: 'Pending', Label: 'Pendiente' },
        { Id: 1, Name: 'Approved', Label: 'Aprobado' },
        { Id: 2, Name: 'Rejected', Label: 'Rechazado' },
    ],
    Groups: {
        Administrator: 'Administrator',
        Consultant: 'Consultant',
        Executor: 'Executor',
        Specialit: 'Specialist',
        Analyst: 'Analyst'
    },
    InfraDigital_API: 'https://api-infradigital.iadb.org/v1',
    ProjectSlug: 'dashboard-obras'

}

export { General }